<template>
  <div>
    <slot name="header" />
    <v-main>
      <div class="mt-24">
        <slot name="content" />
      </div>
    </v-main>
    <v-footer
      app
      fixed
      color="white"
      class="d-flex flex-column"
      width="100%"
      padless
      tile
    >
      <slot name="footer" />
    </v-footer>
  </div>
</template>
<script>
export default {
  name: 'MainLayout',
}
</script>
